import React, {useEffect, useState} from "react";
import Modal from "./Modal";
import {C} from "../styles";
import {apiGetVersion} from "../api/version";

// Injectées au build par la CI (voir .github/workflows/deploy*.yml) ; absentes en dev local.
const FRONTEND_VERSION = process.env.REACT_APP_VERSION || "dev";
const FRONTEND_COMMIT = process.env.REACT_APP_COMMIT_SHA || "local";

function Row({label, value}) {
    return (
        <div style={{display: "flex", justifyContent: "space-between", gap: 12, padding: "6px 0", borderBottom: `1px solid ${C.border}`, fontSize: 13}}>
            <span style={{color: C.textMuted}}>{label}</span>
            <span style={{fontFamily: "monospace", color: C.text}}>{value}</span>
        </div>
    );
}

export default function AboutModal({onClose}) {
    // undefined = chargement, null = échec de l'appel
    const [backend, setBackend] = useState(undefined);

    useEffect(() => {
        apiGetVersion().then(setBackend);
    }, []);

    return (
        <Modal title="À propos de Paroles d'Agents" onClose={onClose}>
            <p style={{fontSize: 13, color: C.textMuted, marginTop: 0}}>
                Utile pour vérifier l'environnement consulté (développement ou production) ou signaler un bug.
            </p>

            <h4 style={{margin: "16px 0 4px", fontSize: 13, color: C.text}}>Application</h4>
            <Row label="Version" value={FRONTEND_VERSION}/>
            <Row label="Commit" value={FRONTEND_COMMIT}/>

            <h4 style={{margin: "16px 0 4px", fontSize: 13, color: C.text}}>Serveur</h4>
            {backend === undefined && <p style={{fontSize: 13, color: C.textMuted}}>Chargement…</p>}
            {backend === null && <p style={{fontSize: 13, color: C.textMuted}}>Informations serveur indisponibles pour le moment.</p>}
            {backend && (
                <>
                    <Row label="Environnement" value={backend.environment}/>
                    <Row label="Version" value={backend.version}/>
                    <Row label="Commit" value={backend.commit}/>
                    {backend.buildDate && (
                        <Row label="Déployé le" value={new Date(backend.buildDate).toLocaleString("fr-FR")}/>
                    )}
                </>
            )}
        </Modal>
    );
}
